export default {
  navigation: {
    next: 'Siguiente',
    back: 'Atrás',
    surveyNavigation: 'Navegación de la encuesta',
    workspace: {
      home: 'Inicio',
      example: 'Ejemplo',
    },
  },
}